export const collapsedSize = 64;
export const sidebarWidth = 236;
